import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const ImprensaInputContainer = styled.div`
  .input-container {
    width: 100%;
    gap: 8px;
  }

  .input-container > div {
    height: ${Tokens.HeightInput};
    padding: 0 16px;
    border: 1.5px solid ${Tokens.ColorBorder};
    border-radius: ${Tokens.RadiusInput};
    background-color: ${Tokens.ColorBackground};
    transition: all 0.2s ease;

    &:hover {
      background-color: ${Tokens.ColorHover};
      border-color: ${Tokens.ColorUIPrimary};
    }

    &:focus-within {
      background-color: ${Tokens.ColorWhite};
      border-color: ${Tokens.ColorUIPrimary};
      box-shadow: 0 0 0 2px rgba(1, 195, 141, 0.15);
    }
  }

  .input-container input {
    font-size: 14px;
    color: ${Tokens.ColorTextPrimary};
    background: transparent;

    &::placeholder {
      color: ${Tokens.ColorTextTertiary};
    }

    &:focus {
      outline: none;
    }
  }

  .input-container label {
    font-size: 14px;
    font-weight: 400;
    color: ${Tokens.ColorTextPrimary};
  }
`

export const GridInputContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 8px;
`
